/*
 * Mimosa — mobile escape bar v7.
 * v7: Menu scrolls to the top FIRST, then opens the menu drawer there
 * (the header is not sticky, so the drawer lives at the top of the page —
 * opening it from deep in the grid showed only its blank backdrop; this is
 * why the original scroll-first version worked and the no-scroll ones
 * did not). Filter opens in place with no scrolling.
 */
(function () {
  'use strict';

  var MOBILE_MAX = 768;
  var SHOW_AFTER = 700;

  function isMobile() { return window.innerWidth <= MOBILE_MAX; }

  function onCollectionPage() {
    return document.querySelector('#filter-results, .collection, main .facets, [data-section-type="main-collection"]') !== null;
  }

  if (!onCollectionPage()) return;

  var bar = document.createElement('div');
  bar.className = 'mimosa-escape-bar';
  bar.setAttribute('role', 'navigation');
  bar.setAttribute('aria-label', 'Collection shortcuts');

  bar.innerHTML = [
    '<button type="button" class="mimosa-escape-btn" data-action="menu" aria-label="Open menu">',
    '  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>',
    '  <span>Menu</span>',
    '</button>',
    '<button type="button" class="mimosa-escape-btn" data-action="filter" aria-label="Open filters">',
    '  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="4" y1="6" x2="20" y2="6"/><line x1="7" y1="12" x2="17" y2="12"/><line x1="10" y1="18" x2="14" y2="18"/></svg>',
    '  <span>Filter</span>',
    '</button>',
    '<button type="button" class="mimosa-escape-btn" data-action="top" aria-label="Back to top">',
    '  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="18 15 12 9 6 15"/></svg>',
    '  <span>Top</span>',
    '</button>'
  ].join('');

  document.body.appendChild(bar);

  var css = document.createElement('style');
  css.textContent = [
    '.mimosa-escape-bar {',
    '  position: fixed; left: 50%; bottom: 16px;',
    '  transform: translate(-50%, 150%);',
    '  display: none; align-items: stretch; gap: 2px; padding: 4px;',
    '  background: rgba(255,255,255,.97);',
    '  border: 1px solid rgba(0,0,0,.10); border-radius: 999px;',
    '  box-shadow: 0 6px 24px rgba(0,0,0,.16); z-index: 40;',
    '  transition: transform .25s ease, opacity .25s ease; opacity: 0;',
    '  backdrop-filter: saturate(1.2) blur(4px);',
    '}',
    '.mimosa-escape-bar.is-visible { transform: translate(-50%, 0); opacity: 1; }',
    '@media (max-width: 768px) { .mimosa-escape-bar { display: flex; } }',
    '.mimosa-escape-btn {',
    '  display: flex; flex-direction: column; align-items: center; justify-content: center;',
    '  gap: 2px; min-width: 72px; padding: 8px 10px;',
    '  font: inherit; font-size: 11px; font-weight: 600; letter-spacing: .02em;',
    '  color: #1a1a1a; background: transparent; border: 0; border-radius: 999px;',
    '  cursor: pointer; -webkit-tap-highlight-color: transparent;',
    '}',
    '.mimosa-escape-btn:active { background: rgba(0,0,0,.06); }',
    '.mimosa-escape-btn svg { display: block; }',
    '@media (prefers-reduced-motion: reduce) { .mimosa-escape-bar { transition: none; } }'
  ].join('\n');
  document.head.appendChild(css);

  var ticking = false;
  function update() {
    ticking = false;
    if (!isMobile()) { bar.classList.remove('is-visible'); return; }
    if (window.scrollY > SHOW_AFTER) bar.classList.add('is-visible');
    else bar.classList.remove('is-visible');
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
  }, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  update();

  function findByText(words) {
    var els = document.querySelectorAll('button, summary, [role="button"], a');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.closest('.mimosa-escape-bar')) continue;
      var t = (el.textContent || '').trim().toLowerCase();
      if (!t || t.length > 40) continue;
      for (var w = 0; w < words.length; w++) {
        if (t.indexOf(words[w]) !== -1) return el;
      }
    }
    return null;
  }

  function isVisible(node) {
    if (!node || node.offsetParent === null) return false;
    var r = node.getBoundingClientRect();
    return r.width > 2 && r.height > 2;
  }

  function findBurger() {
    var candidates = document.querySelectorAll('header button, header summary, header [role="button"]');
    var i;
    for (i = 0; i < candidates.length; i++) {
      var c = candidates[i];
      if (!isVisible(c)) continue;
      var label = ((c.getAttribute('aria-label') || '') + ' ' + c.className + ' ' + (c.textContent || '')).toLowerCase();
      if (label.indexOf('menu') !== -1 || label.indexOf('nav') !== -1) return c;
    }
    for (i = 0; i < candidates.length; i++) {
      if (!isVisible(candidates[i])) continue;
      if (candidates[i].querySelectorAll('svg line').length >= 3) return candidates[i];
    }
    return null;
  }

  // The header is not sticky, so the menu drawer lives at the top of the
  // page. Opening it from deep in the grid shows only its blank backdrop.
  // Therefore: scroll to the top FIRST, then open the menu there (this is
  // the original v1 behaviour, which worked).
  function openMenu() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    var waited = 0;
    var timer = setInterval(function () {
      waited += 100;
      if (window.scrollY < 40) {
        clearInterval(timer);
        var burger = findBurger();
        if (burger) window.setTimeout(function () { burger.click(); }, 150);
      } else if (waited >= 1500) {
        clearInterval(timer);
      }
    }, 100);
  }

  function openFilters() {
    var trigger =
      document.querySelector('.mobile-facets__open, [data-facets-toggle], .facets__disclosure > summary, .js-show-filters, .filter-toggle') ||
      findByText(['filter & sort', 'filter and sort', 'filter']);
    if (trigger) trigger.click();
  }

  bar.addEventListener('click', function (e) {
    var btn = e.target.closest('.mimosa-escape-btn');
    if (!btn) return;
    var action = btn.getAttribute('data-action');
    if (action === 'top') window.scrollTo({ top: 0, behavior: 'smooth' });
    else if (action === 'menu') openMenu();
    else if (action === 'filter') openFilters();
  });
})();
